import type { JobSettingsEmployeeInfo, JobSettingsExceptionItem } from './job-settings.types';

function demoEmployeeInfo(overrides: Partial<JobSettingsEmployeeInfo> = {}): JobSettingsEmployeeInfo {
    return {
        employeeLastName: '',
        checkName: '',
        nameSuffix: '',
        ssnSin: '',
        passwordId: '',
        pcApsId: '',
        commission: '0',
        endDate: '',
        cwaLogin: 0,
        copLogin: 0,
        mopLogin: 0,
        rwaLogin: 0,
        kwaLogin: 0,
        eccoPosLogin: 0,
        isReturns: 0,
        isTimecard: 0,
        isOther: 0,
        jobRates: 0,
        ...overrides,
    };
}

/** 深拷贝员工信息（选行 / 快照用） */
export function cloneJobSettingsEmployeeInfo(info: JobSettingsEmployeeInfo): JobSettingsEmployeeInfo {
    return { ...info };
}

/** 空表单模板（未选行时的 state 占位） */
export function createEmptyJobSettingsEmployeeInfo(): JobSettingsEmployeeInfo {
    return demoEmployeeInfo();
}

/**
 * 「新增员工」弹窗打开时的初始表单：与空模板一致，但六项授权登录（AU）默认全选（1），便于多数场景一次提交。
 */
export function createJobSettingsEmployeeInfoForAddEmployeeDialog(): JobSettingsEmployeeInfo {
    return demoEmployeeInfo({
        cwaLogin: 1,
        copLogin: 1,
        mopLogin: 1,
        rwaLogin: 1,
        kwaLogin: 1,
        eccoPosLogin: 1,
    });
}

/** 例外项初始列表（个人例外待后端契约后从接口填充） */
export function createDefaultJobSettingsExceptions(): JobSettingsExceptionItem[] {
    return [];
}
